import { AnimatePresence, motion } from 'motion/react'
import { ReactNode } from 'react'

type Props = {
  show: boolean
  children: ReactNode
  animationKey?: string
  duration?: number
  ease?: string
  className?: string
}

export default function ExpandFade({
  show,
  children,
  animationKey = 'expand-fade',
  duration = 0.3,
  ease = 'easeOut',
  className = '',
}: Props) {
  return (
    <AnimatePresence mode="wait">
      {show && (
        <motion.div
          key={animationKey}
          initial={{ opacity: 0, height: 0, marginBottom: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0, marginBottom: 0 }}
          transition={{
            duration,
            ease,
          }}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
